var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardOutpatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3334 26L43.3334 22M43.3334 22L47.3334 26M43.3334 22V30M39.3334 46V44.4C39.3334 42.1598 39.3334 41.0397 38.8974 40.184C38.5139 39.4314 37.902 38.8195 37.1494 38.436C36.2937 38 35.1736 38 32.9334 38H27.0667C24.8265 38 23.7064 38 22.8508 38.436C22.0981 38.8195 21.4862 39.4314 21.1027 40.184C20.6667 41.0397 20.6667 42.1598 20.6667 44.4V46M34.6667 28C34.6667 30.5773 32.5774 32.6667 30.0001 32.6667C27.4228 32.6667 25.3334 30.5773 25.3334 28C25.3334 25.4227 27.4228 23.3333 30.0001 23.3333C32.5774 23.3333 34.6667 25.4227 34.6667 28Z",
    stroke: "#175CD3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOutpatient);
export default __webpack_public_path__ + "static/media/card-outpatient.b028a418d9b2cab60c9264be083cb507.svg";
export { ForwardRef as ReactComponent };